import { exam_config_all } from "common_content_config";
import config from "config";

export const generateTruecallerLink = (requestId, timeout) => {
    const baseUrl = 'truecallersdk://truesdk/web_verify';
    const queryParams = new URLSearchParams({
        type: 'btmsheet',
        requestNonce: requestId,
        partnerKey: config.TRUECALLER_PARTNER_KEY,
        partnerName: config.TRUECALLER_PARTNER_NAME,
        lang: 'en',
        privacyUrl: config.AAKASH_PRIVACY_URL,
        termsUrl: config.AAKASH_TERMS_URL,
        loginPrefix: 'continue',
        loginSuffix: 'verifymobile',
        ctaPrefix: 'continuewith',
        ctaColor: '%238230c6',
        ctaTextColor: '%238230c6',
        btnShape: 'rect',
        skipOption: 'useanothernum',
        ttl: `${timeout}`
    });

    return `${baseUrl}?${queryParams.toString()}`;
};

export const getExamType = () => {
    const hostname = window.location.hostname
    if (hostname.includes('neet-mocktest.aakash.ac.in')) {
        return 'MOCK-NEET'
    } else if (hostname.includes('invictus.aakash.ac.in')) {
        return 'IAT'
    } else if (hostname.includes('jee-mocktest.aakash.ac.in')) {
        return 'MOCK-JEE'
    }
    else if (hostname.includes('invictus-opentest.aakash.ac.in')) {
        return 'MOCK-JEE'
    }
    return "iACST"
}

export const getExamConfig = (examType) => {
    let configVal = exam_config_all[examType]
    if (examType == "iACST") {
        const hostname = window.location.hostname
        let pageType = window.location.pathname.substring(1) || 'iacstexam'
        
        if(hostname.includes('aakashdigital.com')){
            pageType = 'adst'
        }
        if (exam_config_all[examType].multiPageConfig && exam_config_all[examType].multiPageConfig[pageType]) {
            configVal = mergeDeep(configVal, exam_config_all[examType].multiPageConfig[pageType])
        }
    }

    return configVal
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

export function formatDateSafe(input) {
    const date = new Date(input)
    if (isNaN(date.getTime())) {
        return 'Invalid Date Format'
    }

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}-${month}-${year}`
}


export const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    const options = { day: 'numeric', month: 'short' }
    const formattedDate = date.toLocaleDateString('en-GB', options)

    const day = date.getDate()
    const suffix = ['th', 'st', 'nd', 'rd'][
        day % 10 > 3 || [11, 12, 13].includes(day) ? 0 : day % 10
    ]
    return `${day}${suffix} ${formattedDate.split(' ')[1]}`
}

export const DateMonthYear = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
};


export const getRegistrationPage = () => {
    const pagesMap = {
        "jee-repeater-scholarship": "iacst_repeater_jee",
        "iacst-medical-engineering-repeater-courses": "iacst_repeater_common",
        "iacst-medical-engineering-repeater-courses-hindi": "iacst_repeater_common_hindi",
        "neet-repeater-scholarship-hindi": "iacst_repeater_neet_hindi",
        "neet-repeater-scholarship": "iacst_repeater_neet",
        "adst": "iacst_adst",
    }

    const key = window.location.pathname.split('/')[1]
    return pagesMap[key] || "default";
}

export const getWebRequestId = () => {
    return window?.webengage?.user?.getAnonymousId ? window?.webengage?.user?.getAnonymousId() : ""
}